module.exports = __webpack_public_path__ + "static/media/linkedIn-Learning-white.56e0f67f.svg";